export function CapitalizeFirst() {

    return function (s) {
        return (angular.isString(s) && s.length > 0) ? s[0].toUpperCase() + s.substr(1).toLowerCase() : s;
    }
}


// WEBPACK FOOTER //
// ./modules/distribution/filters/capitalize_first.js